import React, { useState, useEffect } from 'react';
import styles from './AssignRoleplay.module.scss';
import { useRoleplayStore } from 'features/roleplay/Roleplay.store';
import { TextArea } from 'shared_ui_components';

const RoleplayDescription = () => {
  const [roleplay, setRoleplay] = useState({ label: '', description: '' });

  const {
    formDataCreateRoleplay,
    setFormDataCreateRoleplay,
    formDataAssignRoleplay,
    descriptionError,
    setDescriptionError,
  } = useRoleplayStore();

  const handleChange = (value) => {
    setFormDataCreateRoleplay({ ...formDataCreateRoleplay, description: value });
    setDescriptionError(false);
  };

  useEffect(() => {
    setRoleplay(formDataAssignRoleplay?.roleplay);
  }, [formDataAssignRoleplay, setRoleplay, roleplay]);

  return (
    <>
      {roleplay?.label && formDataAssignRoleplay?.roleplay?.value !== -1 ? (
        <div className={styles.noteBlock}>
          <p className="supportText">{roleplay?.description}</p>
        </div>
      ) : (
        <div>
          <div style={{ display: 'flex', gap: '0.2rem' }}>
            <p className={styles.deadlineTitle}>Description</p>
            <p style={{ color: 'red' }}>*</p>
          </div>
          <TextArea
            rows={3}
            placeholder="Enter new roleplay's description"
            value={formDataCreateRoleplay?.description}
            onChange={(e) => handleChange(e.target.value)}
            error={descriptionError ? 'Required to create custom roleplay' : ''}
          />
        </div>
      )}
    </>
  );
};

export default RoleplayDescription;
